import { AxiosResponse } from 'axios';
import { RegistrationMarriageFormVM } from 'mutation/view-models/registration-marriage';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { DateTime } from 'luxon';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';
import { CivilStatusID } from 'shell/constants/civil-status';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';
import { ActType } from 'shell/constants/act-type';

export const initialValuesRegistrationMarriage: RegistrationMarriageFormVM = {
  searchMarriage: {
    gender: '',
    surname: '',
    name: '',
    withoutName: false,
    withoutSurname: false,
  },
  marriage: {
    person: {
      surname: '',
      name: '',
      withoutName: false,
      withoutSurname: false,
    },
    eventDate: null,
    isForeign: false,
    italian: {
      municipality: null,
    },
    foreign: {
      municipality: null,
    },
    paper: emptyPaper,
    digital: emptyDigital,
    actType: ActType.AttoCartaceo,
    generality: {
      gender: '',
      birthDate: null,
    },
  },
};

export const checkPersonRegistrationMarriage = (civilStatus: string | undefined): boolean => {
  if (civilStatus === CivilStatusID.coniugato || civilStatus === CivilStatusID.unitoCivilmente) {
    return false;
  }

  return true;
};

export const transformerRegistrationMarriageData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): RegistrationMarriageFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  const personData = transformPerson(person);

  const familyCoexistence = transformFamilyCoexistence(person);

  const citizenship = transformCitizenship(person);

  const civilStatus = transformCivilStatus(person);

  return {
    person: personData,
    familyCoexistence,
    citizenship,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    civilStatus: {
      ...(civilStatus || {}),
      oldStatus: civilStatus?.status,
      status: CivilStatusID.coniugato,
    },
    ...initialValuesRegistrationMarriage,
  };
};
